import script from "./PeriodReport2.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodReport2.vue?vue&type=script&setup=true&lang=js"

import "./PeriodReport2.vue?vue&type=style&index=0&id=528f3c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528f3c12"]])

export default __exports__